import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

import { HeldTimesContext } from '../Root/CompetitionRoot';
import { Title } from '../Component/Title';
import { Info } from "../Component/Info"
import { ReturnTopPage } from '../Utility/ReturnTopPage';
import { i18nContext } from '../i18n/i18nContext';

/**
 * 作品登録済み画面
 * 作品登録用のURLで、すでに登録が完了している場合に表示する
 */
export function KaguWorkRegistered() {

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Title>
                    {t("KaguWorkRegistered.Title", heldTimesOption)}
                </Title>
                <Info>
                    {t("KaguWorkRegistered.Text1")}
                </Info>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => ReturnTopPage(lng)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
}